module.exports = __webpack_public_path__ + "static/media/icon-left-font-monochrome-black.abb26b5d.svg";